import actions from './actions'
import constants from './constants'
import selectors from './selectors'

export default {
	actions,
	constants,
	selectors,
}